export var ECustomerImportRedeemStatus;
(function (ECustomerImportRedeemStatus) {
    ECustomerImportRedeemStatus["SUCCESS"] = "success";
    ECustomerImportRedeemStatus["CONVERTED"] = "converted";
    ECustomerImportRedeemStatus["NOTAVAILABLE"] = "notavailable";
})(ECustomerImportRedeemStatus || (ECustomerImportRedeemStatus = {}));
